<template>
  <van-overlay :show="showGetCard" @click="show = false" :lock-scroll="false">
    <div class="wrapper" @click.stop>
      <div class="wrapper-content">
        <img class="get-card-bg" src="@/assets/images/activity/collect-cards/get-card-bg.png" alt="">
        <div class="wrapper-body">
          <p class="wrapper-title">恭喜您获得以下卡牌！</p>
          <p class="wrapper-subtitle" v-if="bonusPointValue">同时获得{{ bonusPointValue }}易加积分</p>
          <p class="wrapper-subtitle">请在“活动页面”中查看</p>
          <div class="bosch-cards">
            <div class="card-drawn" :class="{'card-drawn-one' : bonusPointValue }" v-for="(item, index) in getPieceList" :key="index">
              <div class="card-num">
                <span v-if="bonusPointValue" ></span>
                <span v-else>{{ item.count }}</span>
              </div>
              <div class="card-num"></div>
              <div class="card-text">{{ item.pieceCode }}</div>
            </div>
          </div>
        </div>
        <div class="wrapper-footer">
          <van-button class="button-cancel" @click="close" round :style="{'width' : showActivityButton ? '48%' : '100%'}">知道了</van-button>
          <van-button class="button-confirm" @click="jumpActivity" round v-if="showActivityButton" >查看活动</van-button>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  components: {},
  props: {
    getPieceList: {
      type: Array,
      default: () => {
        return []
      }
    },
    bonusPointValue: {
      type: Number,
      default: 0
    },
    showActivityButton: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showGetCard: false
    }
  },
  computed: {},

  methods: {
    open () {
      this.showGetCard = true
    },
    close () {
      this.showGetCard = false
      this.$emit('after-scan')
    },
    jumpActivity () {
      this.$router.push({ name: 'activity-collectCards' })
      this.showGetCard = false
      this.$emit('after-scan')
    }
  }
}
</script>
<style lang='less' scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  .wrapper-content {
    position: relative;
    width: 75vw;
    background-color: #fff;
    text-align: center;
    box-sizing: border-box;
    border-radius: 10px;
    border: none;

    .wrapper-body {
      padding: 10px;
      padding-bottom: 0px;
      max-height: 50vh;
      overflow-x: hidden;
      overflow-y: auto;

    }

    .wrapper-title {
      margin-top: 35px;
      font-size: 18px;
      line-height: 25px;
      font-weight: 700;
    }

    .wrapper-subtitle {
      font-size: 12px;
      color: #666666;
      margin: 10px 0px;
    }

    .wrapper-footer {
      padding: 15px;

      display: flex;
      align-items: center;
      justify-content: space-between;

      .button-cancel {
        color:#5696A0;
        border-color: #5696A0;
        background-color: #fff;
        font-size: 16px;
        // width: 100%;
      }

      .button-confirm {
        color: #fff;
        border-color: #5696A0;
        background-color: #5696A0;
        font-size: 16px;
      }

      .van-button {
        width: 48%;
      }
    }
  }

  .get-card-bg {
    width: 50%;
    position: absolute;
    top: -60px;
    left: 25%;
    z-index: 9999;
  }
}

.collect-coupon-point {
  height: 70px;
}

.bosch-cards {
  display: flex;
  // align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-left: 0px;
  margin-right: 0px;
  .card-drawn {
    width: 116px;
    // width: 50%;
    height: 171px;
    margin: 5px;
  }

  .card-text {
    font-size: 76px;
    line-height: 171px;
  }

  .card-num {
    font-size: 22px;
    top: 2px;
    left: 6px;
  }
}</style>
